// extracted by mini-css-extract-plugin
export default {"form_container":"GetInTouch_form_container__4tBk7","span_center":"GetInTouch_span_center__IhTNO","form_element":"GetInTouch_form_element__yVioR","button":"GetInTouch_button__pv9aC"};